module.exports = {
  title: '图号信息详情',
  route: {
    path: 'platform-goods-manage',
    children: {
      path: 'platform-goods-detail',
    },
  },
};
